<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">基本信息</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="top" :style="{ 'background-image': 'url(' + user.pic_back + ')' }" @click="wnd_click()"></div>

    <div class="avatar ub ub-pc ub-ac">
      <img :src="user.photo" alt="" />
    </div>

    <div class="info-block">
      <div class="bg-block ub ub-ac2">
        <div class="replace ub ub-pc ub-ac" @click="goto_myphoto()">
          <img src="../../assets/img/new2024/change- avatar.png" alt="" />
          <span>更换头像</span>
        </div>
        <div class="replace ub ub-pc ub-ac" @click="goto_my_bg()">
          <img src="../../assets/img/new2024/change- background.png" alt="" />
          <span>更换背景图</span>
        </div>
      </div>

      <div class="menu-block">
        <ul class="menu">
          <li class="menu-item ub ub-ac ub-pc" @click="goto_my_nickname()">
            <span class="ub ub-ac ub-pc">昵称</span>
            <div class="ub ub-ae ub-pc ub-f1 menu-item-context">
              {{ user.nick }}
            </div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>

          <li class="line"></li>

          <li class="menu-item ub ub-ac ub-pc"  @click="modify_user('sex', user.sex)">
            <span class="ub">性别</span>
            <div class="ub ub-ae ub-pc ub-f1 menu-item-context">
              <span class="sex-tip">(性别只能修改一次)</span>
              {{ user.sex }}
            </div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>

          <li class="line"></li>

          <li class="menu-item ub ub-ac ub-pc" @click="modify_user('age_range', user.age_range)">
            <span>年龄</span>
            <div class="ub ub-ae ub-pc ub-f1 menu-item-context">
              {{ user.age_range }}
            </div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>

          <li class="line"></li>

          <li class="menu-item ub ub-ac ub-pc" @click="goto_loc()">
            <span>位置</span>
            <div class="ub ub-ae ub-pc ub-f1 menu-item-context">
              {{ user.loc_province.length > 6  ? user.loc_province.substr(0, 5) + "..." : user.loc_province}}&nbsp;
              {{ user.loc_city.length > 6 ? user.loc_city.substr(0, 5) + "..." : user.loc_city}}&nbsp;
              {{ user.loc_area }}
            </div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>

          <li class="line"></li>

          <li class="menu-item ub ub-ac ub-pc" @click="goto_my_tags(user.inst_tag,user.sex)">
            <span>标签</span>
            <div class="ub ub-ae ub-pc ub-f1 menu-item-context">
              <li v-for="(item, index) in user.inst_tag" :key="index" class="mark ub ub-pc ub-ac">
                {{ item.length > 3 ? item.substr(0,3) + '...' : item }} 
              </li>
            </div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>

          <li class="line"></li>

          <li class="menu-item ub ub-ac ub-pc" @click="goto_my_hide()">
            <span>隐身</span>
            <div class="ub ub-ae ub-pc ub-f1 ys">
              <img src="../../assets/img/new2024/vip.png" alt="" />
              <span>会员专属</span>
            </div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>

          <li class="line"></li>

          <li class="menu-item ub ub-ac ub-pc" @click="goto_list()">
            <span>上榜隐身</span>
            <div class="ub ub-ae ub-pc ub-f1 ys"></div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>

          <li class="line"></li>

          <li class="menu-item ub ub-ac ub-pc" @click="goto_photo_album()">
            <span>个人相册</span>
            <div class="ub ub-ae ub-pc ub-f1 ys"></div>
            <img src="../../assets/img/箭头.png" class="menu-item-right-img" />
          </li>
        </ul>
      </div>
      <div class="rz-tip" v-if="rz_show">
        <div class="ub">
          <div class="tag1"></div>
          <span
            >请完善个人信息，包括位置和标签，特别是性别，经过认证审核之后的性别不可以再次更改，请如实选择。</span
          >
        </div>
        <div class="ub">
          <div class="tag"></div>
          <span
            >正确的信息有助于提高你在系统中的信任度，有助于你获取更高的收益。</span
          >
        </div>
      </div>

      <div style="height: 2rem"></div>
    </div>


    <dlg ref="myForm_sex" @formBehavior="formact_sex"></dlg>
    <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
    <ryt-dropdown v-model="rytDropdown_sex" :actions="actions_sex" :center="rytDropdown_sex" @clickOption="chooseOption_sex" title="请选择你的性别" cancelText="关闭/取消" cancenTextColor="rgb(250,242,250)"></ryt-dropdown>
    <ryt-dropdown v-model="rytDropdown_age" :actions="actions_age" :center="rytDropdown_age" @clickOption="chooseOption_age" title="请选择你的年龄段" cancelText="关闭/取消" cancenTextColor="rgb(250,242,250)"></ryt-dropdown>
  </div>
</template>
  
  <script>
import * as tool from "../../api/common";
import rytDropdown from "../../components/Dropdown.vue"; //下拉框带popup蒙层
import Form from "../../components/Form.vue";
import Alert from "../../components/Alert.vue";
import { mapMutations, mapActions } from "vuex";
export default {
  components: {
    //注册组件
    rytDropdown,
    dlg: Form,
    alert: Alert,
  },
  data() {
    return {
      user: {
        photo: "",
        nick: "Super",
        sex: "男生",
        age_range: "18-23岁",
        loc_province: "湖北省",
        loc_city: "武汉市",
        loc_area: "武昌区",
        inst_tag: ["大长腿", "御姐"],
        pic_back: "",
        coin_left: 0,
      },
      actions_sex: {
        1: "男生",
        2: "女生",
      },
      rytDropdown_sex: false,

      actions_age: {
        1: "18岁以下",
        2: "18-23岁",
        3: "23岁以上",
      },
      rytDropdown_age: false,

      title: "基本信息",
      rz_show: false,
      sex_count: 0,
      theme_dark: false,
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },

  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo", "act_sub_coin"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_myphoto() {
      this.$router.push({
        name: "my_photo",
        params: { photo: this.user.photo },
      });
    },
    goto_my_nickname() {
      this.$router.push({
        name: "my_nickname",
        params: { nick: this.user.nick },
      });
    },
    goto_my_tags(aryInst,sex) {
      this.$router.push({
        name: "my_tags",
        params: { inst: aryInst.join("|"),sex: sex },
      });
    },
    goto_loc() {
      this.$router.push({ name: "myloc" });
    },
    goto_my_bg() {
      this.$router.push({ name: "my_bg" });
    },
    goto_my_hide() {
      this.$router.push({ name: "my_hide" });
    },
    goto_list() {
      this.$router.push({ name: "hiding_list" });
    },
    goto_photo_album() {
      this.$router.push({ name: "photo_album" });
    },
    init_page() {
      var uid = this.$store.state.uid;
      var self = this;

      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user.uid = u.uid;
          self.user.photo = u.photo;
          self.user.nick = u.nick;
          self.user.sex = u.sex;
          self.user.age_range = u.age_range;
          self.user.loc_province = u.loc_province;
          self.user.loc_city = u.loc_city;
          self.user.loc_area = u.loc_area;
          self.user.inst_tag = u.inst_tag.split("|");
          self.user.pic_back = u.pic_back;
          self.user.coin_left = u.coin_left;

          if (self.user.pic_back == "") {
            self.user.pic_back =
              "http://appdata.jscx666.cn/photo/bg_img/1.jpg";
          }
          //console.log(self.pic_back);
        },
      });

      //加载性别修改次数
      self.get({
        url: "/App/GetUserInfo_SexCount/?uid=" + uid,
        success: function (data) {
          var count = parseInt(data);
          self.sex_count = count;
        },
      });

      //判断是否为 认证跳转过来的
      if (this.$route.params.tag) {
        if (this.$route.params.tag == "rz") {
          this.title = "个人信息认证";
          this.rz_show = true;
        }
      }
    },

    save_serve(send_data) {
      //后台保存信息
      var self = this;
      var uid = this.$store.state.uid;
      //var send_data = {'nick' : nick};
      var data = {
        url: "/App/User_ModifyBaseInfo",
        data: {
          uid: uid,
          data: JSON.stringify(send_data),
        },
        success: function (data_serve) {
          if (data_serve.state == "1") {
            self.act_reload_userinfo({
              uid: uid,
              success: function (info) {
                self.init_page();
              },
            });
          }
        },
      };
      self.post(data);
    },

    modify_user(field, old_val) {
      if (field == "sex") {
        this.rytDropdown_sex = true;
      }
      if (field == "age_range") {
        this.rytDropdown_age = true;
      }
    },
    chooseOption_sex(e) {
      //选中下拉框中的某一项出发的事件
      //判断是否修改过性别
      var sex_cur = this.user.sex;
      var sex = e.item;
      if (sex == sex_cur) {
        return false;
      }
      var sex = e.item;
      var send_data = { sex: sex };

      if (sex_cur != sex && this.sex_count > 0) {
        //修改性别，支付500金币/次
        var coin = 1000 * (this.sex_count * this.sex_count + 1);
        var h ="性别是重要信息，不可随意修改，为了保证其他用户的正常使用，每个用户可以修改一次性别，后续修改性别需支付一定金币，修改次数越多所需支付的金币也越高，本次修改需要支付【" +coin +"】金币，如需修改请点击下方修改按钮";
        this.$refs.myForm_sex.show(h, {
          type: "confirm",
          confirmText: "修改",
          titleText: "温馨提示",
          data: { coin: coin, send_data: send_data },
        });
      } else {
        this.save_serve(send_data);
      }
    },
    chooseOption_age(e) {
      //选中下拉框中的某一项出发的事件
      var age = e.item;
      var send_data = { age_range: age };
      this.save_serve(send_data);
    },

    check_coin(coin_pay) {
      var coin_left = this.user.coin_left;
      if (coin_left < coin_pay) {
        //提示金币不足
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "充值",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      } else {
        return true;
      }
    },

    formact_sex(type, data) {
      if (type == "clickConfirm") {
        //金币检查
        if (!this.check_coin(data.coin)) {
          return false;
        }

        this.sub_coin_sex(data);
      }
    },

    formact_buycoin(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mycoin" });
      }
    },

    //扣除金币
    sub_coin_sex(data) {
      var uid = this.$store.state.uid;
      var send_data = {
        uid_from: uid,
        uid_to: "",
        amount: data.coin,
        type_dtl: "修改性别",
        comment: "",
      };
      var self = this;
      self.act_sub_coin({
        uid: uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          console.log(JSON.stringify(res));
          if (res.state == "1") {
            self.save_serve(data.send_data);
          }
        },
      });
    },

    wnd_click: function () {
      this.rytDropdown_age = false;
      this.rytDropdown_sex = false;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #efefef;
  .nav-top {
    background-color: transparent;
  }
  .line {
    border-top: 1px solid #eeeeee;
  }
}

.top {
  margin-top: -2.6rem;
  height: 16rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.avatar {
  margin-top: -3.2rem;
  img {
    height: 5rem;
    width: 5rem;
    border-radius: 50%;
    border: 1px solid #dcdcdc;
  }
}

.info-block {
  margin-top: -3rem;
  padding: 0 0.8rem;
  background-color: #efefef;
  border: 1px solid #efefef;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  .bg-block {
    margin-top: 3.8rem;
    .replace {
      padding: 1rem 0;
      width: 10rem;
      font-weight: bold;
      color: #333;
      border-radius: 0.5rem;
      background-color: #fdfdfd;
      img {
        width: 1rem;
        height: 1rem;
      }
    }
    span {
      margin-left: 0.5rem;
    }
  }
  .menu-block {
    margin-top: 0.6rem;

    color: #333;
    .menu {
      padding: 0 1.25rem;
      border-radius: 0.5rem;
      background-color: #fdfdfd;
    }
    .menu-item {
      height: 3.75rem;
      line-height: 3.75rem;
      span {
        font-size: 0.9rem;
        color: #333;
      }
      .ys {
        color: #fcdd7f;
        font-size: 0.9rem;
        span {
          margin-left: 0.5rem;
        }
      }
      .menu-item-right-img {
        margin-left: 0.5rem;
        width: 1.25rem;
        height: 1.25rem;
      }

      .menu-item-head {
        height: 4rem;
      }
      .menu-item-name {
        font-size: 0.9rem;
        color: #333;
      }

      .menu-item-context {
        color: #999;
        font-size: 0.9rem;
        .mark {
          height: 1.3rem;
          padding: 0 0.3rem;
          margin-left: 0.5rem;
          border-radius: 0.5rem;
          border: 1px solid #999;
          font-size: 0.9rem;
        }
        .sex-tip {
          font-size: 0.75rem;
          color: rgba(186, 97, 255, 1);
          margin-right: 0.5rem;
        }
      }
    }
  }
}

.rz-tip {
  padding: 0 0.8rem;
  margin-top: 1rem;
  .tag {
    width: 0.5rem;
    height: 1rem;
    background-color: #ba61ff;
    border-radius: 0.5rem;
  }
  .tag1 {
    width: 0.7rem;
    height: 1rem;
    background-color: #ba61ff;
    border-radius: 0.5rem;
  }
  span {
    margin-left: 0.5rem;
    font-size: 0.75rem;
    color: #333;
    line-height: 1.2rem;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2f2e33;
  .info-block {
    background-color: #2f2e33;
    border: 1px solid #2f2e33;
    .bg-block {
      .replace {
        background-color: #2c2b30;
        span {
          color: #fdfdfd;
        }
      }
    }
  }
  .menu-block {
    .menu {
      background-color: #2c2b30;
      .menu-item {
        span {
          color: #666;
        }
        .menu-item-context {
          color: #fdfdfd;
        }
      }
    }
    .line {
      border-top: 1px solid #404040;
    }
  }
  .rz-tip {
    span {
      color: #888;
    }
  }
}
</style>